import { gql } from "../../../__generated__";

export const REVIEW_DISCOVERY_LIST = gql(`
  query reviewDiscoveryList($isNearby: Boolean!, $lat: Float, $lng: Float, $offset: Int!, $limit: Int!) {
    reviewDiscoveryList(isNearby: $isNearby, lat: $lat, lng: $lng, offset: $offset, limit: $limit) {
      id
      user {
        maskedName
      }
      store {
        id
        title
        img
        distance
      }
      orderType
      reviewImages {
        img
      }
      order {
        amount
        totalDiscount
        totalQuantity
      }
      content
      createdAt
    }
  }
`);
